module.exports = __webpack_public_path__ + "static/media/glass-hover.4f78c41c.png";